export const FETCH_RECEIPTS_SUCCESS = 'RECEIPTS::FETCH_RECEIPTS_SUCCESS';
export const FETCH_RECEIPTS_ERROR = 'RECEIPTS::FETCH_RECEIPTS_ERROR';

export const POST_PUSH_NEXUS_RECEIPT_SUCCESS =
  'RECEIPTS::POST_PUSH_NEXUS_RECEIPT_SUCCESS';
export const POST_PUSH_NEXUS_RECEIPT_ERROR =
  'RECEIPTS::POST_PUSH_NEXUS_RECEIPT_ERROR';

export const RESET = 'RECEIPTS::RESET';
